<template>
  <div>
    <div class="station-name">
      <i class="fa fa-map-marker text-danger align-baseline"/>&nbsp;
      <span class="text-monospace">{{ selectedStation.NAME }}</span>
    </div>
    <div v-show="!unlockedCars.length">
      <b-alert
        show
        variant="info">All car has been submitted</b-alert>
      <b-btn
        block
        variant="secondary"
        @click="done()">Done</b-btn>
    </div>
    <b-alert
      :show="alerts.error"
      variant="danger">{{ alerts.errorMsg }}</b-alert>
    <div v-show="unlockedCars.length">
      <b-form-group>
        <label class="d-block">Available vehicles</label>
        <select
          v-model="selectedCar"
          class="form-control d-inline"
          @change="resetModel()">
          <option
            v-for="car in unlockedCars"
            :key="car.CODE"
            :value="car">{{ car.NAME + ' - ' +car.LICENSE_PLATE }}</option>
        </select>
      </b-form-group>
      <transition-group
        :duration="300"
        tag="div"
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut">
        <div :key="1">
          <b-form-group
            label="REMARK:">
            <span v-if="!model.NOTE">-</span>
            <h5><b-badge variant="warning">{{ model.NOTE }}</b-badge></h5>
          </b-form-group>
          <b-form-group
            label="ODOMETER:"
            label-for="odometer">
            <b-form-input
              id="odometer"
              v-model="model.MILEAGE"
              type="text"/>
          </b-form-group>
          <b-form-group
            label="EXTERIOR:"
            label-for="exterior">
            <label class="switch switch-pill switch-success">
              <input
                v-model="model.EXTERIOR"
                :car-code="model.CODE"
                type="checkbox"
                class="switch-input">
              <span class="switch-slider"/>
            </label>
          </b-form-group>
          <b-form-group
            label="INTERIOR:"
            label-for="interior">
            <label class="switch switch-pill switch-success">
              <input
                v-model="model.INTERIOR"
                :car-code="model.CODE"
                type="checkbox"
                class="switch-input">
              <span class="switch-slider"/>
            </label>
          </b-form-group>
          <b-form-group
            label="BOOT:"
            label-for="boot">
            <label class="switch switch-pill switch-success">
              <input
                v-model="model.BOOT"
                :car-code="model.CODE"
                type="checkbox"
                class="switch-input">
              <span class="switch-slider"/>
            </label>
          </b-form-group>
        </div>
        <div
          :key="2"
          class="d-block">
          <image-uploader
            :preview="true"
            :class-name="['fileinput', { 'fileinput--loaded': hasImage }]"
            :max-size="1000"
            :debug="0"
            :auto-rotate="true"
            capture="environment"
            output-format="blob"
            @input="setImage" >
            <label
              slot="upload-label"
              :class="{'mt-2': hasImage}"
              class="btn btn-block btn-success"
              for="fileInput">
              <i class="icon-camera"/> Take Picture
            </label>
          </image-uploader>
        </div>
      </transition-group>
      <b-btn
        v-if="!alerts.noCarAvailable && !alerts.lockFailed"
        :disabled="isPosting || !hasImage"
        block
        variant="primary"
        @click="submit">
        Submit & Lock
        <i
          v-show="isPosting"
          class="fa fa-spinner fa-spin"/>
      </b-btn>
      <b-btn
        v-show="alerts.lockFailed"
        block
        variant="warning"
        @click="submit">
        Resend lock command
      </b-btn>
    </div>
  </div>
</template>
<script>
import findIndex from 'lodash/findIndex'

import { toastr } from '@/services/'
import { sendEvent } from '@/services/socket'

// to fix cleaner behaviour, wash the car first then submit the data.
// use localStorage instead vuex state.
// CleaningForm2 will set the data needed for this form.
export default {
  name: 'CleaningForm3',
  data () {
    return {
      model: {},
      file: null,
      alerts: {
        error: false,
        lockFailed: false
      },
      hasImage: false,
      isPosting: false,
      selectedStation: JSON.parse(localStorage.selectedStation),
      unlockedCars: JSON.parse(localStorage.unlockedCars),
      selectedCar: {}
    }
  },
  created () {
    this.selectedCar = this.unlockedCars[0]
    this.model = Object.assign({}, this.selectedCar)
  },
  methods: {
    resetModel() {
      this.model = Object.assign({}, this.selectedCar)
      // reset image
      this.$el.querySelector('.img-preview').setAttribute('src', '')
      this.hasImage = false
      this.file = null
    },
    setImage (output) {
      this.hasImage = true
      this.file = output
    },
    async submit () {
      sendEvent('CLEANER_EVENT', {
        page: '/cleaning',
        eventName: `SUBMIT_CLEANING_LOG_${this.selectedCar.LICENSE_PLATE}`,
        eventDetail: {
          licensePlate: this.selectedCar.LICENSE_PLATE
        }
      })
      // process to be done :
      // 1. lock vehicle
      // 2. cancel reservation
      // 3. post image to get imageUrl
      // 4. post cleaning log
      this.isPosting = true
      this.alerts.lockFailed = false
      // lock car
      let payloadLock = {
        carCode: this.model.CODE,
        carLockUnlock: 0
      }
      let lockCar = await this.$store.dispatch('cleaning/lockUnlockCar', payloadLock)
      .then( resp => resp, err => err )
      // if lock car failed then stop the process
      if (lockCar.data.msgContent.errMsg && lockCar.data.msgContent.status < 0) {
        toastr.error('Failed to lock vehicle.')
        this.alerts.lockFailed = true
        this.isPosting = false
        return false
        // end
      }

      // cancel reservation
      this.$store.dispatch('cleaning/cancelReservation', this.model.LICENSE_PLATE)
      //upload image
      let fileUrl = await this.$store.dispatch('cleaning/uploadImage', this.file)
      .then(resp => resp, err => err)

      if (!fileUrl) {
        toastr.serverError()
        return false
      }

      let payloadCleaningLog = [{
        interior: this.model.INTERIOR ? 1 : 0,
        exterior: this.model.EXTERIOR ? 1 : 0,
        boot: this.model.BOOT ? 1 : 0,
        mileage: this.model.MILEAGE.toString(),
        carInStationCode: this.model.CIST_CODE,
        picUrl: fileUrl
      }]
      // post cleaning log
      this.$store.dispatch('cleaning/saveCleaningLog', payloadCleaningLog).then(
        () => {
          this.isPosting = false
          // reset image
          this.$el.querySelector('.img-preview').setAttribute('src', '')
          this.hasImage = false
          this.file = null

          let idx = findIndex(this.unlockedCars, {CODE: this.model.CODE})
          this.unlockedCars.splice(idx, 1)

          if (!this.unlockedCars.length) {
            localStorage.removeItem('unlockedCars')
            localStorage.removeItem('selectedStation')
          } else {
            this.selectedCar = this.unlockedCars[0]
            this.model = Object.assign({}, this.selectedCar)
          }
        },
        err => {
          this.isPosting = false
          this.alerts.error = true
          if (err.response.status === 403) {
            this.alerts.errorMsg = 'Vehicle has been submitted before.'
          } else {
            this.alerts.errorMsg = err.response.data.msgContent
          }
        }
      )
    },
    done () {
      location.reload()
    }
  },
}
</script>
